import { Components } from 'react-markdown';

export const markdownComponents: Components = {
  h1: ({ children }) => <h1 className="text-2xl font-bold mt-5 mb-2 first:mt-2">{children}</h1>,
  h2: ({ children }) => <h2 className="text-xl font-bold mt-4 mb-2">{children}</h2>,
  h3: ({ children }) => <h3 className="text-lg font-bold mt-3 mb-2">{children}</h3>,
  h4: ({ children }) => <h4 className="text-md font-bold mt-2 mb-2">{children}</h4>,
  h5: ({ children }) => <h5 className="text-sm font-bold mt-1 mb-2">{children}</h5>,
  h6: ({ children }) => <h6 className="text-sm font-bold mt-1 mb-2">{children}</h6>,
  p: ({ children }) => <p className="text-md mb-2">{children}</p>,
  ul: ({ children }) => <ul className="list-disc list-inside mb-2">{children}</ul>,
  table: ({ children }) => <table className="w-full my-4">{children}</table>,
  tr: ({ children }) => <tr className="border-b border-gray-200">{children}</tr>,
  td: ({ children }) => <td className="p-2">{children}</td>,
  th: ({ children }) => <th className="p-2">{children}</th>,
  code: ({ children }) => <code className="bg-gray-100 p-1 rounded-md mb-4">{children}</code>,
  pre: ({ children }) => <pre className="bg-gray-100 p-2 rounded-md mb-4">{children}</pre>,
  blockquote: ({ children }) => (
    <blockquote className="border-l-4 border-gray-300 pl-4 mb-4">{children}</blockquote>
  ),
  li: ({ children }) => <li className="text-md [&>p]:mb-0 [&>p]:inline">{children}</li>,
};
